export enum PREFIX {
  COLOR = '--color-',
  FONT = '--font-',
  SPACING = '--spacing-',
  LOADER = '--loader-',
}
